<div class="wrapper">
  <app-environment-notification></app-environment-notification>
  <app-header (authChange)="onAuthEvent($event)"></app-header>

  <mat-sidenav-container *ngIf="!(isFullPageMode$ | async)"  (backdropClick)="toggleSideNav(false)">
    <mat-sidenav
      [mode]="(isTabletLandscapeUp$ | async) ? 'side' : 'over'"
      [opened]="(isSideNavOpen$ | async)!">
      <div class="sidenav-container">
        <div class="settings-history-container scrollbar">
          <mat-tab-group>
            <mat-tab label="{{ 'settings.title' | translate }}">
              <div class="tab-content">
                <app-settings></app-settings>
                <app-expert-mode></app-expert-mode>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <button
        class="mobile-menu-cta"
        [ngClass]="{ 'show-for-mobile': isMenuMobileVisible }"
        (click)="toggleIsMenuMobileVisible()">
        <mat-icon class="arrow-up">menu</mat-icon>
      </button>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <ng-container *ngIf="isFullPageMode$ | async">
    <router-outlet></router-outlet>
  </ng-container>
</div>
